const cropHeaders = ({ crop }) => ({
  "X-Image-Crop-Width": String(Math.round(crop.width)),
  "X-Image-Crop-Height": String(Math.round(crop.height)),
  "X-Image-Crop-X": String(Math.round(crop.x)),
  "X-Image-Crop-Y": String(Math.round(crop.y)),
});

const fitHeaders = ({ aspectRatio, background }) => ({
  "X-Image-Fit": "contain",
  "X-Image-Aspect-Ratio": String(aspectRatio),
  "X-Image-Background": background,
});

export const uploadRequestFor = ({
  fileType,
  productTypeId,
  mode,
  ...edit
}) => ({
  url: `/api/user/imageUpload?${new URLSearchParams({
    bn: "productImage",
    productTypeId: productTypeId ?? "other",
  })}`,
  headers: {
    "Content-Type": fileType,
    ...(mode === "fit" ? fitHeaders(edit) : cropHeaders(edit)),
  },
});
